module.exports = __webpack_public_path__ + "img/error-illustration.9d16eebd.svg";